export default {
    computed : {
        showInventorySourceUpsell () {
            return this.$store.state.dealer_portal.settings['account.b2b.inventorysource_upsell']
        },
        inventorySourcePromoCode () {
            return this.$store.state.dealer_portal.settings['account.b2b.inventorysource_promo_code'];
        },
        inventorySourceSupplierId () {
            return this.$store.state.dealer_portal.settings['account.b2b.inventorysource_supplier_id'];
        },
        showProducts () {
            return this.$store.state.dealer_portal.settings['account.b2b.allow_showing_products']
               && this.$store.state.dealer_portal.settings.show_products_menu_item;
        },
        showCheckout () {
            return this.$store.state.dealer_portal.settings['account.b2b.show_checkout']
               && this.$store.state.dealer_portal.settings.show_products_menu_item;
        },
        showExport () {
            return this.$store.state.dealer_portal.settings['account.b2b.show_feed_link'];
        },
    },
};
